// removed by extract-text-webpack-plugin
module.exports = {"button":"_34CUsCUGpVIye2mkRmgMJM","button-icon":"_3SVdmRzS7BZQYINIOWAQcV","icon-add":"XKBBsDGNPdDKYkCzwGRKC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Skills/components/AddSkillButton.mod.css
// module id = 1720
// module chunks = 0